const dateInput = document.querySelector(".flat-picker");
const timeInput = document.querySelectorAll(".flat-time-picker");
if (dateInput) {
    const fp = flatpickr(dateInput, {
        locale: "fr",
        dateFormat: "d/m/Y"
    });
}

if (timeInput) {
    const tp = flatpickr(timeInput, {
        locale: "fr",
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
    });
}
